module.exports = __webpack_public_path__ + "static/img/home-item1.0616829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item1.png
// module id = Ku73
// module chunks = 21